(function (global, factory) {
  'use strict';

  var api = factory();
  if (typeof module === 'object' && module && module.exports) module.exports = api;
  if (global) global.WvrStickyAtc = api;
  if (typeof document !== 'undefined') api.autoInit();
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';

  function stickyState(configuration) {
    var state = configuration || {};
    return { ready: state.status === 'ready', missing: state.missing || 'vr-system' };
  }

  function initializeConfigurator(doc, win, configurator) {
    var shell = doc.querySelector('[data-wvr-sticky-atc]');
    if (!shell) return null;

    var section = configurator.closest('[data-wvr-onestock-tier-root]') || doc;
    var primaryAction = section.querySelector('[data-wvr-primary-action]');
    var addToCartButton = primaryAction ? primaryAction.querySelector('button.wvr03-atc[name="add"]') : null;
    var action = shell.querySelector('[data-wvr-sticky-atc-submit]');
    var actionLabel = shell.querySelector('[data-wvr-sticky-atc-label]');
    var link = shell.querySelector('[data-wvr-sticky-atc-link]');
    var observer = null;
    var primaryVisible = true;

    if (!action || !actionLabel || !addToCartButton || !primaryAction) return null;
    if (shell.parentElement !== doc.body) doc.body.appendChild(shell);
    shell.removeAttribute('hidden');
    if (link) link.hidden = true;
    action.hidden = false;

    function currentConfiguration() {
      var controller = configurator.wvrConfiguratorController;
      if (controller && typeof controller.getConfiguration === 'function') {
        return controller.getConfiguration();
      }
      return {
        status: configurator.dataset.wvrConfigStatus || 'missing-vr',
        missing: configurator.dataset.wvrConfigStatus === 'missing-system'
          ? 'other-system'
          : configurator.dataset.wvrConfigStatus === 'missing-mount' ? 'mount-type' : 'vr-system'
      };
    }

    function labelFor(configuration) {
      var state = stickyState(configuration);
      if (state.ready) return configurator.dataset.labelAddToCart || '';
      if (state.missing === 'other-system') return configurator.dataset.labelChooseSystem || '';
      if (state.missing === 'mount-type') return configurator.dataset.labelChooseMount || '';
      return configurator.dataset.labelChooseVr || '';
    }

    function sync() {
      var configuration = currentConfiguration();
      var state = stickyState(configuration);
      var pending = addToCartButton.dataset.wvrSubmitPending === 'true';
      action.disabled = pending || addToCartButton.disabled;
      action.setAttribute('aria-disabled', action.disabled ? 'true' : 'false');
      actionLabel.textContent = state.ready && addToCartButton.disabled
        ? addToCartButton.textContent.trim() : labelFor(configuration);
      shell.dataset.wvrStickyAtcState = state.ready ? 'ready' : state.missing;
      var mobile = win.innerWidth < 768;
      var visible = mobile && !primaryVisible;
      shell.toggleAttribute('inert', !visible);
      shell.classList.toggle('is-visible', visible);
      shell.setAttribute('aria-hidden', visible ? 'false' : 'true');
    }

    action.addEventListener('click', function () {
      var configuration = currentConfiguration();
      if (action.disabled) return;
      if (stickyState(configuration).ready) {
        addToCartButton.click();
      } else if (typeof configurator.wvrRequestSelection === 'function') {
        configurator.wvrRequestSelection();
      }
    });

    doc.addEventListener('wvr:configuration-change', sync);
    doc.addEventListener('wvr:submit-state', sync);
    new MutationObserver(sync).observe(addToCartButton, { attributes: true, attributeFilter: ['disabled', 'data-wvr-submit-pending'], childList: true, characterData: true, subtree: true });
    win.addEventListener('resize', sync);
    if (typeof win.IntersectionObserver === 'function') {
      observer = new win.IntersectionObserver(function (entries) {
        primaryVisible = entries.length ? entries[0].isIntersecting : true;
        sync();
      }, { threshold: 0.01 });
      observer.observe(primaryAction);
    } else {
      var updateVisibility = function () {
        var rect = primaryAction.getBoundingClientRect();
        primaryVisible = rect.bottom > 0 && rect.top < win.innerHeight;
        sync();
      };
      win.addEventListener('scroll', updateVisibility, { passive: true });
      updateVisibility();
    }
    sync();
    return { shell: shell, sync: sync, observer: observer };
  }

  function initializeLegacy(doc, win) {
    var original = doc.querySelector('.product-form__buttons-checkout');
    if (!original) return null;
    var sticky = original.cloneNode(true);
    sticky.classList.add('sticky-checkout-button');
    doc.body.appendChild(sticky);
    var originalAdd = original.querySelector('button.wvr03-atc[name="add"]');
    var stickyAdd = sticky.querySelector('button.wvr03-atc[name="add"]');
    if (stickyAdd && originalAdd) {
      stickyAdd.removeAttribute('style');
      stickyAdd.addEventListener('click', function (event) {
        event.preventDefault();
        originalAdd.click();
      });
      var syncLegacy = function () {
        stickyAdd.innerHTML = originalAdd.innerHTML;
        stickyAdd.disabled = originalAdd.disabled;
        stickyAdd.setAttribute('aria-disabled', originalAdd.getAttribute('aria-disabled') || String(originalAdd.disabled));
      };
      new MutationObserver(syncLegacy).observe(originalAdd, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'], childList: true, subtree: true, characterData: true });
      syncLegacy();
    }
    function toggleSticky() {
      if (win.innerWidth > 767) {
        sticky.classList.remove('show');
        return;
      }
      var rect = original.getBoundingClientRect();
      sticky.classList.toggle('show', rect.top > win.innerHeight || rect.bottom < 0);
    }
    win.addEventListener('scroll', toggleSticky, { passive: true });
    win.addEventListener('resize', toggleSticky);
    toggleSticky();
    return sticky;
  }

  function init(doc, win) {
    var targetDoc = doc || document;
    var targetWin = win || window;
    var configurator = targetDoc.querySelector('[data-wvr-tier-configurator]');
    return configurator
      ? initializeConfigurator(targetDoc, targetWin, configurator)
      : initializeLegacy(targetDoc, targetWin);
  }

  function autoInit() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(document, window); });
    } else {
      init(document, window);
    }
  }

  return {
    stickyState: stickyState,
    initializeConfigurator: initializeConfigurator,
    initializeLegacy: initializeLegacy,
    init: init,
    autoInit: autoInit
  };
});
